import React from 'react';

import Copyright from 'lego-on-react/src/components/copyright/copyright.react';

import 'lego-on-react/src/components/copyright/copyright.css';

export default function () {
    return <Copyright start={2014} />;
}
